
import {
    RouterProvider,
} from "react-router-dom";
import { Button } from "semantic-ui-react";

import { router } from "./router";
import { useVersionCheck } from "./hooks/useVersionCheck";

// Suppress React 18.3 defaultProps deprecation warnings from semantic-ui-react v2
const _origConsoleError = console.error.bind(console.error);
console.error = (...args: any[]) => {
  if (typeof args[0] === 'string' && args[0].includes('defaultProps')) return;
  _origConsoleError(...args);
};

export default function App() {
    const { updateAvailable } = useVersionCheck();

    return (
        <>
            {updateAvailable && (
                <div style={{
                    position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000,
                    background: "#000", color: "#fff", padding: "12px 16px",
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    gap: 12,
                }}>
                    <span>A new version is available.</span>
                    <Button size="small" primary onClick={() => window.location.reload()}>
                        Refresh
                    </Button>
                </div>
            )}
            <RouterProvider router={router} fallbackElement={<p>Initial Load...</p>} />
        </>
    );
}
